/** Web client-meta headers (keep in sync with backend clientMetaHeaders.js WEB_CLIENT_HEADERS). */
export const CLIENT_META_HEADERS = {
  appVersion: "x-cw8f2a",
  appBuildNumber: "x-cw7k1p",
  deviceType: "x-cw3t8n",
  deviceModel: "x-cw5h4r",
  systemVersion: "x-cw2s6v",
  bundleId: "x-cw8b0d",
  deviceId: "x-cw4u9x",
  deviceOs: "x-cw1r7l",
  ipAddress: "x-cw6n3q",
};
